var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"justify-center",attrs:{"color":"#292929","height":"100"}},[_c('div',{staticClass:"title font-weight-light grey--text text--lighten-1 text-center"},[_vm._v("\n    © "+_vm._s(new Date().getFullYear())+" — Technosylva\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }